export default {
	document: 'CPF',
	project_name: 'Academia Repintura',
	in_case_of_doubts_about_the_operation_of_the_platform_points_or_any_information_not_related_to_the_content_of_the_courses_fill_out_the_form_to_contact_our_support_team_our_response_time_is_7_working_days:
		'Em caso de dúvidas sobre o funcionamento da plataforma, pontos, ou qualquer informação, preencha o formulário para entrar em contato com nossa equipe de suporte SAC/Tech-line da AkzoNobel.',
	platform_meta_description:
		'Academia Repintura, a plataforma de treinamentos da AkzoNobel para aperfeiçoar a sua carreira no mundo da Repintura Automotiva.',
	company_agency: 'División',
	regionals: 'País/Regionales',
	country: 'Región',
	content_navbar: 'Entrenamientos',
	document: 'Documento',
}
